module.exports = __webpack_public_path__ + "static/media/logo-ipn.d8612060.png";